import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { Autocomplete, Box, IconButton, Modal, TextField, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import EditLabor from "./EditLabor";
import {
    useCreateLaborMutation,
    useDeleteLaborMutation,
    useGetLaborQuery,
} from "../../../Services/inventory/Inventory";
import LoadingSpinner from "../../../components/LoadingSpinner";
import EmptyRows from "../../../components/reusableComponent/EmptyRows";
import DeleteModal from "../DeleteModal";
import useThemeColors from "../../vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";
import {
    useGetAllServiceDataQuery,
    useGetSubServiceOnIdBasisDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";

const MasterLabor = () => {
    const [duration, setDuration] = useState(""); // store duration as "HH:MM"

    const [defaultRate, setDefaultRate] = useState("");
    const [laborData, setLaborData] = useState([]);
    const [tableLoader, setTableLoader] = useState(false);
    const [laborDetails, setLaborDetails] = useState({});
    const [openEditLaborModal, setOpenEditLaborModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [loading, setLoading] = useState<any>(false);
    const [subServiceTableData, setSubServiceTableData] = useState([]);
    const [serviceTypeId, setServiceTypeId] = useState<any>("");
    const [serviceTableData, setServiceTableData] = useState([]);
    const [subServiceTypeId, setSubServiceTypeId] = useState<any>("");

    const { data: subServiceData } =
        useGetSubServiceOnIdBasisDataQuery(serviceTypeId);
    const { data: serviceData } = useGetAllServiceDataQuery({});

    useEffect(() => {
        if (subServiceData) {
            setSubServiceTableData(subServiceData);
        }
    }, [subServiceData]);

    useEffect(() => {
        if (serviceData) {
            setServiceTableData(serviceData?.results);
        }
    }, [serviceData]);

    const [errors, setErrors] = useState({
        serviceName: false,
        duration: false,
        defaultRate: false,
    });

    const masterLaborHeader = [
        { label: "Sr. No.", key: "Sr.no" },
        { label: "Labour id", key: "labor_id" },
        { label: "Service name", key: "service_name" },
        { label: "Sub service name", key: "sub_service_name" },

        { label: "Service time", key: "test_time" },
        { label: "Price", key: "default_rate" },
    ];

    const [createLaborTrigger, { status }] = useCreateLaborMutation();
    const { data: masterLaborData, isLoading, refetch } = useGetLaborQuery({});
    const [triggerDeleteLaborId] = useDeleteLaborMutation();

    useEffect(() => {
        if (masterLaborData) {
            setLaborData(masterLaborData?.data);
        }
    }, [masterLaborData]);

    useEffect(() => {
        if (status === "pending") {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [status]);



    console.log(serviceTypeId, "serviceTypeId")
    const saveHandler = async (e) => {
        e.preventDefault();
        
        const newErrors = {
            serviceName: !serviceTypeId,
            duration: !duration.trim(),
            defaultRate: !defaultRate.trim(),
        };
        console.log(errors, "wedcsdcsdcs")

        setErrors(newErrors);

        const hasError = Object.values(newErrors).some((err) => err);
        if (hasError) {
            toast.error("Please fill all required fields");
            return;
        }

        const obj = {
            service_name: serviceTypeId,
            test_time: `${duration}:00`,
            default_rate: defaultRate,
            sub_service_name : subServiceTypeId
        };

        try {
            const response = await createLaborTrigger(obj);

            if (response?.data) {
                toast.success("Added successfully");
                refetch();
                setDuration('')
                setDefaultRate("")
                setServiceTypeId('')
            setSubServiceTypeId('')

            } else if (response?.error) {
                toast.error("An error occurred");
            }
        } catch (error) {
            toast.error("Unexpected error");
        }
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "40%",
        overflow: "scroll",
        bgcolor: "background.paper",
        border: "1px solid transparent",
        boxShadow: 2,
        borderRadius: "5px",
        p: 4,
        paddingBottom: "0",
    };

    const isEditModal = (laborDetails) => {
        setLaborDetails(laborDetails);
        setOpenEditLaborModal(true);
    };

    const isDeleteModal = (labor) => {
        setOpenDeleteModal(true);
        setLaborDetails(labor);
    };

    const closeModal = () => {
        setOpenEditLaborModal(false);
        setOpenDeleteModal(false);
    };

    const generateDurationSlots = () => {
        const times: string[] = [];
        for (let hour = 0; hour <= 12; hour++) {
            for (let min of ["00", "30"]) {
                if (hour === 0 && min === "00") continue; // skip 0:00
                times.push(`${hour}:${min}`);
            }
        }
        return times;
    };

    const durationSlots = generateDurationSlots();

    const formatToHHMMSS = (time: string) => {
        if (!time) return "00:00:00";
        const [h, m] = time.split(":");
        const hours = h.padStart(2, "0");
        const minutes = m.padStart(2, "0");
        const seconds = "00";
        return `${hours}:${minutes}:${seconds}`;
    };

    const {
        selectedColor,
        selectedBackgroundColor,
        selectedBorderColor,
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();

    return (
        <div className="vehicle-info-cont">
            {/* <div 
                className="vehicle-info-middle"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
             
            //  className='sub_cont' style={{marginBottom: "20px"}}
             >

      

            <div className='top_order' style={{display: "flex", gap: "10px"}}>
                <div style={{display: "flex", gap: "5px", flexDirection: "column"}}><label>Service name</label><input style={{padding: "15px"}}  placeholder="Service name..." className='form-control' value={serviceName} onChange={(e) => setServiceName(e.target.value)}/></div>
                <div style={{display: "flex", gap: "5px", flexDirection: "column"}}><label>Test time</label>

                <Autocomplete
        freeSolo
        options={durationSlots}
        value={duration}
        onChange={(_, newValue) => {
          setDuration(newValue || "");
        }}
        style={{ width: "200px"}}
        renderInput={(params) => (
          <TextField
          style={{padding: "3px 5px", height: "20px"}}
            {...params}
            fullWidth
            placeholder="Enter duration like 2:30"
            onChange={(e) => {
              setDuration(e.target.value);
            }}
          />
        )}
      />

      </div>


                <div style={{display: "flex", gap: "5px", flexDirection: "column"}}><label>Default Rate</label><input style={{padding: "15px"}} placeholder="Rate..." className='form-control' value={defaultRate} onChange={(e) => setDefaultRate(e.target.value)}/></div>
            </div>

          <div style={{ display: "flex", justifyContent: "end" }}>
                        <button
                            onClick={saveHandler}
                            // disabled={!brandName.trim()}
                            style={{
                                background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                                  //  cursor: brandName.trim() ? "pointer" : "not-allowed",


                            }}
                        >
                            Save
                        </button>
                    </div>
            </div> */}

            <div
                className="vehicle-info-middle"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
            >
                <div className="vehicle-info-middle-heading">Add Labor Cost</div>
                <div
                    className="vehicle-info"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <div
                        className="top_order"
                        style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "space-between",
                            alignItems: "baseline"
                        }}
                    >
                        {/* <div style={{display: "flex", gap: "5px", flexDirection: "column", width: "100%"}}><label className='required'>Service name</label><input style={{padding: "10px", borderRadius: "20px"}}  placeholder="Service name..." className='form-control' value={serviceName} onChange={(e) => setServiceName(e.target.value)}/></div> */}

                        <div style={{ width: "100%" }}>
                            <p
                                className="vehicle-class"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <span
                                    className="required"
                                    style={{
                                        paddingLeft: "10px",
                                        // marginBottom: "10px",
                                    }}
                                >
                                    Service type
                                </span>
                                <span>
                                    <select
                                        value={serviceTypeId}
                                        onChange={(e) =>
                                            setServiceTypeId(e.target.value)
                                        }
                                        style={{
                                            background: "#FCFCFC",
                                            width: "100%",
                                            borderRadius: "30px",
                                            padding: "9px 15px",
                                            fontSize: "14px"
                                        }}
                                    >
                                        <option>Select an option</option>

                                        {serviceTableData?.map(
                                            (service, index) => (
                                                <option value={service?.id}>
                                                    {service?.name}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </span>
                            </p>
                        </div>

                        <div style={{ width: "100%" }}>
                            <p
                                className="vehicle-class"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <span
                                    className="required"
                                    style={{
                                        paddingLeft: "10px",
                                        // marginBottom: "10px",
                                    }}
                                >
                                    Sub service
                                </span>
                                <span>
                                    <select
                                        value={subServiceTypeId}
                                        onChange={(e) =>
                                            setSubServiceTypeId(e.target.value)
                                        }
                                        style={{
                                            background: "#FCFCFC",
                                            width: "100%",
                                            borderRadius: "30px",
                                            padding: "9px 15px",
                                            fontSize: "14px"
                                        }}
                                    >
                                        <option style={{fontSize: "10px"}}>Select an option</option>
                                        {subServiceTableData?.map(
                                            (subService, index) => (
                                                <option value={subService?.name}>
                                                    {
                                                        subService
                                                            ?.name
                                                    }
                                                </option>
                                            )
                                        )}
                                    </select>
                                </span>
                            </p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                // gap: "5px",
                                flexDirection: "column",
                                width: "100%",
                            }}
                        >
                            <label className="required" style={{fontSize: "16px",     color: "#6C6D70", marginBottom: "-2px", padding: "0 10px"}}>Service time</label>

                            <Autocomplete
                                freeSolo
                                options={durationSlots}
                                value={duration}
                                onChange={(_, newValue) => {
                                    setDuration(newValue || "");
                                }}
                                style={{ width: "100%", borderRadius: "50px" }}
                                renderInput={(params) => (
                                    <TextField
                                        style={{
                                            padding: "3px 5px",
                                            height: "17px",
                                            borderRadius: "50px",
                                        }}
                                        {...params}
                                        fullWidth
                                        placeholder="Enter duration like 2:30"
                                        onChange={(e) => {
                                            setDuration(e.target.value);
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                // gap: "5px",
                                flexDirection: "column",
                                width: "100%",
                            }}
                        >
                            <label className="required" style={{fontSize: "16px",     color: "#6C6D70", padding: "0 10px"}}><i className="bi bi-currency-rupee" style={{color: "black", fontSize: "15px"}}></i>Price</label>
                            <input
                                style={{
                                    padding: "9px 15px",
                                    borderRadius: "20px",
                                }}
                                placeholder="Price..."
                                className="form-control"
                                value={defaultRate}
                                onChange={(e) => setDefaultRate(e.target.value)}
                            />
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <button
                            onClick={saveHandler}
                            // disabled={!brandName.trim()}
                            style={{
                                background: `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                                //  cursor: brandName.trim() ? "pointer" : "not-allowed",
                            }}
                        >
                            {loading ? (
                                <>
                                    Saving...
                                    <Loader />
                                </>
                            ) : (
                                "Save"
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <div
                className="vehicle-info-bottom"
                style={{
                    boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
                    borderRadius: "35px",
                }}
            >
                <div className="row">
                    <div className="col">
                        <div
                            style={{
                                backgroundColor: "rgb(247, 211, 197)",
                                padding: "10px 30px",
                            }}
                        >
                            <div className="row align-items-center">
                                {masterLaborHeader?.map((card, index) => (
                                    <div className="col" key={index}>
                                        <label htmlFor="">
                                            <strong
                                                style={{
                                                    display: "flex",
                                                    gap: "2px",
                                                    alignItems: "center"
                                                }}
                                            >
                                                {card?.label === "Price" ? <><i className="bi bi-currency-rupee" style={{color: "black", fontSize: "15px"}}></i> {card.label}</> : card.label}
                                            </strong>
                                        </label>
                                    </div>
                                ))}
                                <div className="col text-end">
                                    <label
                                        htmlFor=""
                                        style={{ paddingRight: "25px" }}
                                    >
                                        <strong>Action</strong>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {isLoading || tableLoader ? (
                        <LoadingSpinner />
                    ) : (
                        <>
                            {!laborData?.length ? (
                                <EmptyRows value={""} />
                            ) : (
                                <div
                                    className="col"
                                    style={{ paddingRight: "0px" }}
                                >
                                    <>
                                        {laborData?.length ? (
                                            <>
                                                {laborData?.map(
                                                    (
                                                        labor: any,
                                                        index: any
                                                    ) => (
                                                        <div
                                                            className="card p-4"
                                                            style={{
                                                                background:
                                                                    index %
                                                                        2 ===
                                                                    0
                                                                        ? "white"
                                                                        : "#FFF1EC",
                                                            }}
                                                            key={index}
                                                        >
                                                            <div
                                                                className="row align-items-start"
                                                                style={{
                                                                    padding:
                                                                        "0px 25px",
                                                                }}
                                                            >
                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                        }}
                                                                    >
                                                                        {index +
                                                                            1}
                                                                    </label>
                                                                </div>

                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                        }}
                                                                    >
                                                                        {
                                                                            labor?.labour_id
                                                                        }
                                                                    </label>
                                                                </div>

                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                        }}
                                                                    >
                                                                        {
                                                                            capitalizeFirstLetter(labor?.service_name_display)
                                                                        }
                                                                    </label>
                                                                </div>
                                                                  <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                        }}
                                                                    >
                                                                        {
                                                                            capitalizeFirstLetter(labor?.sub_service_name)
                                                                        }
                                                                    </label>
                                                                </div>

                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "15px",
                                                                        }}
                                                                    >
                                                                        {
                                                                            labor?.test_time
                                                                        }
                                                                    </label>
                                                                </div>

                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "18px",
                                                                        }}
                                                                    >
                                                                        {labor?.default_rate}
                                                                    </label>
                                                                </div>

                                                                <div
                                                                    className="col text-center d-flex"
                                                                    style={{
                                                                        gap: "10px",
                                                                        justifyContent:
                                                                            "end",
                                                                        paddingRight:
                                                                            "25px",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="text-hover-primary border-0 bg-white me-2"
                                                                        title="Edit"
                                                                        // onClick={() =>
                                                                        //     EditModal(
                                                                        //       inventory.id
                                                                        //     )
                                                                        // }
                                                                        onClick={() =>
                                                                            isEditModal(
                                                                                labor
                                                                            )
                                                                        }
                                                                    >
                                                                        <i
                                                                            className="bi bi-pencil"
                                                                            style={{
                                                                                fontSize:
                                                                                    "20px",
                                                                                cursor: "pointer",
                                                                                background:
                                                                                    index %
                                                                                        2 ===
                                                                                    0
                                                                                        ? "white"
                                                                                        : "#FFF1EC",
                                                                            }}
                                                                        ></i>
                                                                    </button>
                                                                    <button
                                                                        className="text-hover-danger border-0 bg-white me-2"
                                                                        title="Delete"
                                                                        onClick={() =>
                                                                            isDeleteModal(
                                                                                labor
                                                                            )
                                                                        }
                                                                    >
                                                                        <i
                                                                            className="bi bi-trash"
                                                                            style={{
                                                                                fontSize:
                                                                                    "20px",
                                                                                cursor: "pointer",
                                                                                background:
                                                                                    index %
                                                                                        2 ===
                                                                                    0
                                                                                        ? "white"
                                                                                        : "#FFF1EC",
                                                                            }}
                                                                        ></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </>
                                        ) : (
                                            ""
                                            // <EmptyRows value={""} />
                                        )}
                                    </>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Modal
                open={openEditLaborModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                                                            id="modal-title"
                                                            variant="h6"
                                                            component="h2"
                                                            sx={{ mb: 2 }}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            Edit Labour cost
                                                        </Typography>

                    <Box>
                        <EditLabor
                            closeModal={closeModal}
                            refetch={refetch}
                            storeValue={laborDetails}
                            // agentMappingQueueData={agentMappingQueueData}
                        />
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={openDeleteModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        <GridCloseIcon />
                    </IconButton>
                    {/* <Typography
                                                                                                id="modal-title"
                                                                                                variant="h6"
                                                                                                component="h2"
                                                                                                sx={{ mb: 2 }}
                                                                                                style={{
                                                                                                    display: "flex",
                                                                                                    justifyContent: "center",
                                                                                                }}
                                                                                            >
                                                                                                Delete Inventory
                                                                                            </Typography> */}

                    <Box>
                        <DeleteModal
                            closeModal={closeModal}
                            refetch={refetch}
                            storeValue={laborDetails}
                            triggerDelete={triggerDeleteLaborId}
                            // agentMappingQueueData={agentMappingQueueData}
                        />
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default MasterLabor;
